/**
 * TanStack Query hooks for `enterprise-plan`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	enterprisePlanQueryKeys,
	type CreateEnterprisePlanBody,
	type ListEnterprisePlanResponse,
	type EnterprisePlanRow,
} from "./api";

export function useEnterprisePlanList(): UseQueryResult<ListEnterprisePlanResponse, Error> {
	return useQuery({
		queryKey: enterprisePlanQueryKeys.list(),
		queryFn: list,
	});
}

export function useEnterprisePlanCreate(): UseMutationResult<EnterprisePlanRow, Error, CreateEnterprisePlanBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: enterprisePlanQueryKeys.all });
		},
	});
}

export function useEnterprisePlanDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: enterprisePlanQueryKeys.all });
		},
	});
}
